import React, { useCallback, useRef, useState } from 'react'
import CookieConsent from 'react-cookie-consent'
import {
  Root,
  Wrapper,
  Row,
  Copy,
  Disclaimer,
  Controls,
  Actions,
  CloseButton
} from './index.styled'
import Button from 'components/ui-elements/button'
import { useAppLayout } from 'layouts/main'

const CONSENT_DAYS = 150
const MOBILE_PILL = { width: 92, height: 24, fontSize: 12 }

const CookiesBanner = () => {
  const { showSplash } = useAppLayout()
  const consent = useRef(null)
  const [dismissed, setDismissed] = useState(false)

  const visible = !dismissed && !showSplash

  const accept = useCallback(() => {
    consent.current?.accept()
    setDismissed(true)
  }, [])

  return (
    <Root>
      <CookieConsent
        ref={consent}
        location='none'
        disableStyles
        disableButtonStyles
        buttonText='ok'
        buttonClasses='cookies-banner-accept-btn'
        expires={CONSENT_DAYS}
        hideOnAccept={false}
      >
        <Wrapper $visible={visible} aria-hidden={!visible}>
          <Row>
            <Copy>This website uses cookies to ensure you get the best experience on our website.</Copy>
            <Controls>
              <Actions>
                <Button
                  as='button'
                  width={113}
                  height={28}
                  fontSize={16}
                  mobile={MOBILE_PILL}
                  onClick={accept}
                >
                  Accept
                </Button>
                <Button
                  to='/legal'
                  width={113}
                  height={28}
                  fontSize={16}
                  mobile={MOBILE_PILL}
                >
                  Learn More
                </Button>
              </Actions>
              <CloseButton
                type='button'
                aria-label='Close cookie notice'
                onClick={() => setDismissed(true)}
              />
            </Controls>
          </Row>
          <Disclaimer>
            This advertisement is not an offering. It is a solicitation of interest in the advertised
            property. No offering of the advertised units can be made and no deposits can be accepted,
            or reservations, binding or non-binding, can be made until an offering plan is filed with
            the New York State Department of Law. This advertisement is made pursuant to Cooperative
            Policy Statement #1, issued by the New York State Department of Law. CP 26-0098. Sponsor:
            419 PAS LLC, having an address c/o El Ad US Holding, Inc., 645 Madison Ave 16th Floor
            New York, NY 10022.
          </Disclaimer>
        </Wrapper>
      </CookieConsent>
    </Root>
  )
}

export default CookiesBanner
